module.exports = __webpack_public_path__ + "img/board_btn_b.82317dd7.png";